<template>
    <div style="min-height:400px">
        <ElTableEdit
                ref="editTable"
                :data="btnList"
                :columns="columns"
                border
                stripe
                style="width: 100%"
                :header-cell-style="headerStyle"
                :cell-style="cellStyle"
                @submitRow="submit">
                            <template v-slot:column-actions="{ row, $index }" >
                                <el-button @click="delItem(row, $index)"
                                           type="danger" icon="el-icon-delete" size="small">
                                </el-button>
                            </template>
        </ElTableEdit>
        <div style="text-align: center;padding: 20px 0 10px 0">
            <el-button type="success" @click="showIcon" size="medium">图标预览</el-button>
            <el-button type="primary" @click="add" size="medium">新 增</el-button>
            <el-button type="primary" @click="addGroup" size="medium">批量新增</el-button>
            <el-button type="warning" @click="save" size="medium">确 认</el-button>
        </div>

        <button v-show="false"
                ref="copy"
                data-clipboard-action="copy"
                :data-clipboard-text="copyData">
        </button>

        <IconsDialog v-if="showIconDialog"
                     ref="iconDialog"
                     :formData="formData"
                     :loading="dialogLoading"
                     @closeDialog="closeDialog"
                     @selIcon="selIcon">
        </IconsDialog>

        <btnGroup v-if="showBtnGroup"
                     ref="btnGroup"
                     :dataList="btnList"
                     :btnGroup="btnGroup"
                     @submit="selBtn"
                     @closeDialog="closeDialog">
        </btnGroup>
    </div>
</template>

<script>
    import Clipboard from 'clipboard';
    import IconsDialog from "@/components/system/icon/IconsDialog";
    import btnGroup from "@/components/system/menumanage/menuBtnGroup";

    export default {
        name: "menuBtn",
        props: ['formData', 'loading'],
        components: {IconsDialog,btnGroup},
        data() {
            return {
                copyData: "",
                showIconDialog: false,
                showBtnGroup: false,
                dialogLoading: false,
                columns: [
                    {
                        title: "按钮名",
                        key: "buttonName",
                        edit: true,
                        width: "120",
                        // rules: [
                        //     {required: true, message: "请输入按钮名称"},
                        // ],
                        clearable: true,
                    },
                    {
                        title: "按钮方法",
                        key: "method",
                        edit: true,
                        width: "120",
                        // rules: [
                        //     {required: true, message: "请输入按钮方法"},
                        // ],
                        clearable: true,
                    },
                    {
                        title: "样式",
                        key: "type",
                        // type: "select",
                        options: [{
                            "value": "primary"
                        }, {
                            "value": "warning"
                        }, {
                            "value": "danger"
                        }, {
                            "value": "success"
                        }, {
                            "value": "info"
                        }],
                        edit: true,
                        width: "150",
                        rules: [],
                        clearable: true,
                    },
                    {
                        title: "图标",
                        key: "icon",
                        type: "icon",
                        width: "200",
                        edit: true,
                        rules: [],
                        clearable: true,
                    },
                ],
                btnList: [],
                saveData: [],
                delData: [],
                btnGroup:[{
                    icon: "el-icon-circle-plus-outline",
                    method: "add",
                    buttonName: "新增",
                    type: "primary",
                },{
                    icon: "el-icon-edit",
                    method: "edit",
                    buttonName: "修改",
                    type: "warning",
                },{
                    icon: "el-icon-delete",
                    method: "delete",
                    buttonName: "删除",
                    type: "danger",
                },{
                    icon: "el-icon-delete",
                    method: "cancel",
                    buttonName: "撤销",
                    type: "danger",
                },{
                    icon: "el-icon-view",
                    method: "view",
                    buttonName: "查看",
                    type: "success",
                },{
                    icon: "el-icon-download",
                    method: "import",
                    buttonName: "导入",
                    type: "primary",
                },{
                    icon: "el-icon-upload2",
                    method: "outport",
                    buttonName: "导出",
                    type: "primary",
                },{
                    icon: "el-icon-share",
                    method: "subFlow",
                    buttonName: "提交流程",
                    type: "warning",
                },{
                    icon: "el-icon-printer",
                    method: "print",
                    buttonName: "下载打印",
                    type: "warning",
                }]
            };
        },
        async mounted() {
            if(this.formData.menuId)
                await this.getMenuBtnList();
        },
        methods: {
            async getMenuBtnList() {
                let param = {
                    url:"/systembutton/findByMenuId",
                    param:{
                        menuId: this.formData.menuId,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode === '0') {
                    this.btnList = data.data;
                }
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            add() {
                let index = this.btnList.findIndex(item => {
                    return item._edit === true
                })
                if (index > -1) {
                    this.$message({message: '请先保存记录', type: 'error'});
                } else {
                    this.btnList.push({
                        "_edit": true
                    })
                }
            },
            addGroup() {
                this.showBtnGroup = true;
            },
            selBtn(list){
                this.saveData = this.saveData.concat(list)
                this.btnList = this.btnList.concat(list)
                this.showBtnGroup = false;
            },
            save() {
                let saveForm = {
                    saveData: this.saveData,
                    delData: this.delData,
                }
                if(this.formData.menuId){
                    saveForm.saveData.map(item=>{
                        item.menuId = this.formData.menuId
                    })
                    saveForm.delData.map(item=>{
                        item.menuId = this.formData.menuId
                    })
                }
                this.$emit("saveBtn", saveForm);
            },
            submit(row, valid) {
                if (valid) {
                    if (row.buttonId) {
                        let flag = false;
                        this.saveData.map(item => {
                            if (item.buttonId === row.buttonId) {
                                flag = true;
                                item = row;
                            }
                        })
                        if(!flag){
                            this.saveData.push(row);
                        }
                    } else {
                        this.saveData.push(row);
                    }
                    row._edit = false;
                    // 验证通过
                } else {
                    // 验证不通过
                }
            },
            delItem(row) {
                this.$confirm('是否确认删除该记录继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    if(row.buttonId){
                        let index = this.btnList.findIndex(item => {
                            return item.buttonId === row.buttonId
                        })
                        if (index > -1) {
                            this.delData.push(row);
                        }
                        this.btnList.splice(index, 1);
                    }else{
                        let index = this.btnList.findIndex(item => {
                            return item.method === row.method
                        })
                        this.btnList.splice(index, 1);

                        let saveIndex = this.saveData.findIndex(item => {
                            return item.method === row.method
                        })
                        if (saveIndex > -1) {
                            this.saveData.splice(saveIndex, 1);
                        }
                    }
                })
            },
            showIcon() {
                this.showIconDialog = true;
            },
            closeDialog() {
                this.showIconDialog = false;
                this.showBtnGroup = false;
            },
            async selIcon(icon) {
                this.showIconDialog = false;
                this.copyData = icon;

                this.$nextTick(() => {
                    var clipboard = new Clipboard(this.$refs.copy);
                    clipboard.on("success", () => {
                        this.$message({message: '已复制到剪切板', type: 'success'});
                        clipboard.destroy();
                    });
                    clipboard.on("error", () => {
                        this.$message({message: "该浏览器不支持自动复制", type: "warning",});
                        // 释放内存
                        clipboard.destroy();
                    });
                    this.$refs.copy.click();
                })
            },
        },
    }
</script>

<style scoped>

    /deep/ .el-table .el-table__cell {
        padding: 5px;
    }

    /*.el-table td, .el-table th {*/
    /*    padding: 10px;*/
    /*}*/
    /deep/ .el-table {
        overflow-y: auto !important;
    }

    /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }
</style>
